import type { AxiosError } from "axios";
import type { ProductCategory } from "@/features/dmManagement/types";
import { GetProductCategoriesAPI } from "@/features/dmManagement/api";
import { useApiClient } from "@/hooks/useApiClient";

interface UseProductCategoriesReturn {
  categories: ProductCategory[] | undefined;
  isLoading: boolean;
  error: AxiosError | undefined;
}

/**
 * 商品カテゴリ一覧を取得するカスタムフック。
 * デザイン作成・編集時の商品カテゴリ選択に使用する。
 */
export const useProductCategories = (): UseProductCategoriesReturn => {
  const { apiClient } = useApiClient();
  const { data, isLoading, error } = GetProductCategoriesAPI(apiClient);

  return {
    categories: data,
    isLoading,
    error,
  };
};
